import { DateTime } from 'luxon'

export class BoxAllocation {
	public id: number
	public playerId: number
	public salesforceId: string
	public boxNumber: string
	public operatingSystem: string
	public startDate: DateTime
	public endDate: DateTime
	public active: boolean
	public model: string
	public mdmDeviceId: string
	public metadata: BoxAllocationMetadata

	constructor(data: {
		id: number
		playerId: number
		salesforceId: string
		boxNumber: string
		operatingSystem: string
		startDate: DateTime
		endDate: DateTime
		active: boolean
		model: string
		mdmDeviceId: string
		metadata: BoxAllocationMetadata
	}) {
		this.id = data.id
		this.playerId = data.playerId
		this.salesforceId = data.salesforceId
		this.boxNumber = data.boxNumber
		this.operatingSystem = data.operatingSystem
		this.startDate = data.startDate
		this.endDate = data.endDate
		this.active = data.active
		this.model = data.model
		this.mdmDeviceId = data.mdmDeviceId
		this.metadata = data.metadata
	}

	static create(partial: Partial<BoxAllocation>): BoxAllocation {
		const defaults = {
			id: 0,
			playerId: 0,
			salesforceId: '',
			boxNumber: '',
			operatingSystem: '',
			startDate: DateTime.now(),
			endDate: DateTime.now(),
			active: false,
			model: '',
			mdmDeviceId: '',
			metadata: BoxAllocationMetadata.create({}),
		}

		// Merge defaults with provided data
		return new BoxAllocation({ ...defaults, ...partial })
	}
}

export class BoxAllocationMetadata {
	public isGeneric: boolean | null
	public brand: string | null
	public osVersion: string | null
	public ethernetMacAddress: string | null
	public wifiMacAddress: string | null

	constructor(data: {
		isGeneric: boolean | null
		brand: string | null
		osVersion: string | null
		ethernetMacAddress: string | null
		wifiMacAddress: string | null
	}) {
		this.isGeneric = data.isGeneric
		this.brand = data.brand
		this.osVersion = data.osVersion
		this.ethernetMacAddress = data.ethernetMacAddress
		this.wifiMacAddress = data.wifiMacAddress
	}

	static create(
		partial: Partial<BoxAllocationMetadata>
	): BoxAllocationMetadata {
		const defaults = {
			isGeneric: null,
			brand: null,
			osVersion: null,
			ethernetMacAddress: null,
			wifiMacAddress: null,
		}

		// Merge defaults with provided data
		return new BoxAllocationMetadata({ ...defaults, ...partial })
	}
}
